import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { getIsAuthorized } from 'src/reducers/user/userSelectors';
import { PATHS } from 'src/constants/paths';

interface Props {
  children: JSX.Element;
}

function AuthorizedRoute({ children }: Props): JSX.Element | null {
  const isAuthorized = useSelector(getIsAuthorized);

  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthorized) {
      navigate(PATHS.LOGIN, { replace: true });
    }
  }, [isAuthorized, navigate]);

  if (!isAuthorized) {
    return null;
  }

  return children;
}

export default AuthorizedRoute;
